import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=4d896b84&scoped=true&"
import script from "./ProductCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d896b84",
  null
  
)

export default component.exports